import {
  U21Button,
  U21ButtonProps,
} from 'app/shared/u21-ui/components/input/U21Button';
import { U21Typography } from 'app/shared/u21-ui/components/display/typography/U21Typography';

export interface U21DocsLinkProps extends Omit<
  U21ButtonProps,
  'children' | 'color' | 'href' | 'tooltip' | 'variant'
> {
  children?: string;
  docsLink: string;
}

export const U21DocsLink = ({
  children = 'Need help?',
  docsLink,
  ...rest
}: U21DocsLinkProps) => {
  return (
    <U21Button color="info" variant="text" href={docsLink} {...rest}>
      <U21Typography color="info" variant="body2">
        {children}
      </U21Typography>
    </U21Button>
  );
};
